// Store global variables here
// Usage: import { API_URL } from '../../Config';

//SERVER ROUTES
export const USER_SERVER = '/api/users';
export const GROUP_SERVER = '/api/group';
export const POST_SERVER = '/api/post';
export const POSTCOMMENT_SERVER = '/api/postcomment';
export const IMAGE_URL = '';
export const DOMAIN_URL = window.location.host === 'bjjdrills.com' || window.location.host === 'www.bjjdrills.com' ? window.location.origin + '/' : 'http://localhost:5000/';